<div class="container p-4 px-xl-0 account-deletion-container">
  <h1 class="text-uppercase">{{'account-deletion.success.header' | translate }}</h1>
  <p class="mb-4"> {{'account-deletion.success.headerText' | translate }}</p>

  <div class="row gap-3 py-2">
    <button class="col-120 col-lg-auto btn btn-primary" (click)="toHomepage()">
      {{'account-deletion.success.toHomepage' | translate }}
    </button>
  </div>
</div>
